import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import SectionWrapper from 'components/SectionWrapper'

const tubeHeight = em(360)
const tubeHeightMd = em(520)

export const EatIcon = styled.img`
  width: ${em(66)};
`

export const TubeWrapper = styled.div`
  position: relative;
  height: ${tubeHeight};

  ${p => p.theme.mq.upMd} {
    height: ${tubeHeightMd};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: absolute;
  left: 0;
  top: 0;
  width: ${em(300)};
  max-width: 100%;

  ${p => p.theme.mq.upMd} {
    bottom: -2em;
    left: 70%;
    width: 119%;
    top: auto;
    max-width: ${em(400)};
    height: auto;
    transform: translateX(-50%);
    max-height: ${em(640)};
  }

  ${p => p.theme.mq.upLg} {
    top: -20%;
    bottom: auto;
    max-height: none;
    left: 56%;
    width: ${em(350)};
  }
`

export const SectionWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.blueDark};
`
